<template>
  <Plan>
    <div class="listNavController">
      <div @click="jumpDetile" class="title" :class="act === '2' ? 'act' : ''">
        企业基本信息
      </div>
      <div
        v-if="$store.state.userinfo.first_in.toString() !== '1'"
        @click="jumpList"
        class="title"
        :class="act === '1' ? 'act' : ''"
      >
        所代理的生产商资料
      </div>
    </div>
  </Plan>
</template>
<script>
// import Api from "@/plugins/axios.js";
import Plan from "@/components/Plan.vue";
export default {
  props: {
    act: {
      default: "1",
      type: [String, Number]
    }
  },
  components: { Plan },
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    jumpList() {
      this.$router.push({
        name: "InfoList"
      });
    },
    jumpDetile() {
      this.$router.push({
        name: "AgentInfo"
      });
    }
  }
};
</script>
<style lang="less" scoped>
// 企业信息列表的切换条
.listNavController {
  display: flex;
  .title {
    color: rgba(153, 153, 153, 1);
    text-align: center;
    margin-right: 50px;
    padding-bottom: 12px;
    margin-top: -8px;
    margin-bottom: -20px;
    cursor: pointer;
  }
  .act {
    color: #0082a4;
    border-bottom: 2px solid #0082a4;
  }
}
</style>
